import type { FC } from 'react';

const Hero: FC = () => {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20dreamy%20cherry%20blossom%20petals%20falling%20in%20a%20warm%20golden%20sunset%20light%2C%20abstract%20artistic%20style%20with%20soft%20pink%20and%20warm%20cream%20tones%2C%20gentle%20gradient%20background%20with%20floating%20sakura%20petals%2C%20ethereal%20atmosphere%2C%20clean%20minimalist%20composition%2C%20dreamy%20anime-inspired%20aesthetic%2C%20no%20text%2C%20no%20characters%2C%20pure%20atmospheric%20background&width=1800&height=900&seq=hero-bg-sakura-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/10 to-background-50"></div>

      <div className="section-container relative z-10 w-full py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-xs font-semibold tracking-wider mb-5">
              动漫资源平台
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
              91樱花
              <br className="sm:hidden" />
              <span className="text-white/90 font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                {' '}最新动漫资源一站式入口
              </span>
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-medium mb-3">
              永久域名 · 防封地址 · 安全访问
            </p>

            <p className="text-sm md:text-base text-white/65 max-w-lg mx-auto lg:mx-0 leading-relaxed mb-8">
              91樱花网专注为动漫爱好者提供最新、最全的动漫资源聚合服务。覆盖2026夏季新番、经典老番、国漫精选、剧场版动画等全品类内容，
              支持多线路高清播放，每日同步更新。本站采用最新防封技术，提供永久域名和备用入口，确保你随时随地安全访问，追番不断档。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-1.5 text-white/80">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/80">
                  <i className="ri-fire-line text-white text-sm"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">每日更新 30+ 部</span>
              </div>
              <div className="flex items-center gap-1.5 text-white/80">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/80">
                  <i className="ri-shield-check-line text-white text-sm"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">永久域名防封</span>
              </div>
              <div className="flex items-center gap-1.5 text-white/80">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/80">
                  <i className="ri-hd-line text-white text-sm"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">4K超清画质</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm transition-all duration-200 text-center whitespace-nowrap"
              >
                立即探索热门
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#faq"
                className="w-full sm:w-auto px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm transition-all duration-200 text-center border border-white/20 whitespace-nowrap"
              >
                收藏防封地址
                <i className="ri-bookmark-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20anime-style%20illustration%20of%20a%20beautiful%20cherry%20blossom%20tree%20under%20a%20starry%20night%20sky%2C%20soft%20pink%20petals%20floating%20in%20the%20air%2C%20magical%20atmosphere%20with%20gentle%20glowing%20lights%2C%20warm%20dreamy%20color%20palette%20of%20soft%20pinks%20and%20deep%20purples%2C%20Japanese%20anime%20art%20style%2C%20highly%20detailed%20illustration%2C%20ethereal%20and%20romantic%20mood&width=900&height=720&seq=hero-visual-sakura-01&orientation=landscape"
                alt="91樱花 - 动漫资源平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                <span className="text-white/90 text-xs font-medium">在线 · 稳定运行中</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;